<!-- Used for displaying messages to the end user -->
<!-- Reference the tcems-utilities service to see how the rest of the system can load messages into the angular message framework for these toasts to be used -->
<p-toast key="sticky" position="top-center"></p-toast>
<p-toast key="normal" position="top-center"></p-toast>

<div class="flex flex-column p-2" style="height:90vh;">

    <!--Handle login events that come from the login module-->
    <app-login></app-login>
    <div class="align-items-start" style="min-height:75px; max-height:75px">

        <p-menubar id="topMenu" [model]="topMenuModel" appendTo="body">

            <ng-template pTemplate="end">

                <div class="flex flex-row-reverse align-items-center">
                    <div class="p-2">
                        HEMI v{{version}}<br>
                        <p-checkbox *ngIf="betaShowOverride" [(ngModel)]="betaActive" [binary]="true" (onChange)="betaToggle()" label="Beta"></p-checkbox>
                    </div>
                    <div *ngIf="loggedIn" class="flex flex-row-reverse align-items-center">
                        <div class="justify-content-center p-2">
                            <p-avatar
                                label="{{loginStatus.currentUser.firstName.substr(0,1)}}{{loginStatus.currentUser.lastName.substr(0,1)}}"
                                shape="circle" [style]="{'background-color':'#2196F3','color':'#FFFFFF'}"></p-avatar>
                        </div>
                        <div class="flex justify-content-end p-2" style="width:150px;">
                            {{loginStatus.currentUser.firstName.substr(0,1)}} {{loginStatus.currentUser.lastName}}<br>(Ext.{{loginStatus.currentUser.extNumber}})
                        </div>
                    </div>
                    <div *ngIf="!loggedIn">
                        Not Logged In
                    </div>
                    <div #twilioDiv>
                        <p-splitButton #twilioButton  [model]="twilioButtonOptions" label="{{taskrouterButtonLabel}}" [style]="{'width':'75px'}"
                            [styleClass]="taskrouterButtonClass" (onClick)="taskrouterButtonClick()" (onDropdownClick)="taskrouterDropDownClick()">
                        </p-splitButton >
                    </div>

                    <div *ngIf="taskrouterPopUpColor" style="border: 3px solid #DD0000; background: #FFFF00;"><strong>HPI PRIOR AUTH<br>{{taskrouterWhiteLabelAndCid}}</strong>&nbsp;&nbsp;</div>
                    <div *ngIf="!taskrouterPopUpColor"><strong>{{taskrouterWhiteLabelAndCid}}</strong>&nbsp;&nbsp;</div>

                    <p-overlay #phiResults mode="overlay" [appendTo]="twilioDiv" [(visible)]="showResults" contentStyleClass="p-4 surface-overlay shadow-2 border-round">
                        <ng-template pTemplate="content">
                        <p-table *ngIf="phiSearchResults != null" [value]="phiSearchResults">
                            <ng-template pTemplate="body" let-phiSearchResult>
                                <tr>
                                    <td><a href="#"
                                            (click)="twilio.updateTwilioNumber(phiSearchResult.phiId)">{{phiSearchResult.result.firstName}}
                                            {{phiSearchResult.result.lastName}} {{phiSearchResult.result.dob | date:'shortDate' }}</a></td>
                                </tr>
                            </ng-template>
                        </p-table>
                        <p-progressSpinner *ngIf="phiSearchResults == null"></p-progressSpinner>
                        </ng-template>
                    </p-overlay>
                   
                </div>

                <div class="grid flex-row-reverse align-items-center flex vertical-container">

                </div>
            </ng-template>

        </p-menubar>
    </div>

    <!--Middle Page Content-->
    <div class="shadow-10  p-2 fill-vert">
        <p-overlayPanel #op>
            <ng-template pTemplate>
            </ng-template>
        </p-overlayPanel>
        <div class="grid fill-vert">
            <!-- And this is our side menu-->
            <div *ngIf="centerPanelType==CPT_SPLIT_2_10" class="col-2 fill-vert">
                <p-panelMenu [model]="sideMenuModel"></p-panelMenu>
            </div>

            <!-- <div class="row">             -->
                <!-- this is our main panel in the center of the page-->
                <div id="contentPanel" class="{{centerPanelType==CPT_SINGLE ? 'col-12 fill-vert' : 'col-10 fill-vert'}} ">

                    <router-outlet></router-outlet>
                </div>
        </div>
    </div>
</div>
<app-sidebar></app-sidebar>
